import { gql } from 'graphql-tag'

const hesburgerServicePromptnessFragment = gql`
  fragment HesburgerServicePromptnessFragment on HesburgerServicePromptness {
    cashier
    driveIn
    selfServiceCashier
    app
    foodora
    all
    isActionRequired
  }
`

export const fetchHesburgerServicePromptness = gql`
  query FetchHesburgerServicePromptness($stationId: ID!, $date: String!) {
    hesburgerServicePromptness(stationId: $stationId, date: $date) {
      ...HesburgerServicePromptnessFragment
    }
  }
  ${hesburgerServicePromptnessFragment}
`

export const saveHesburgerServicePromptness = gql`
  mutation SaveHesburgerServicePromptness(
    $stationId: ID!
    $date: String!
    $data: UpsertHesburgerServicePromptnessInput!
  ) {
    upsertHesburgerServicePromptness(stationId: $stationId, date: $date, data: $data) {
      ...HesburgerServicePromptnessFragment
    }
  }
  ${hesburgerServicePromptnessFragment}
`
